import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    selectedContent: {},
    isLogging: false,
}

export const playListContent = createSlice({
    name: 'selectPlaylist',
    initialState,
    reducers: {
        setContentDetails: (state, action) => {
            state.selectedContent = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const {setContentDetails} = playListContent.actions

export default playListContent.reducer
